<ion-header>
  <ion-toolbar color="medium">
    <ion-title>{{title}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">Cancel</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar placeholder="Search..." [(ngModel)]="search" (ionInput)="filter()" [debounce]="150">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-item button detail="false" *ngIf="selectedTid" (click)="clear()">
      <ion-label color="danger">Clear selection</ion-label>
    </ion-item>
    <ion-item button detail="false" *ngFor="let item of visible" (click)="choose(item)"
      [color]="item.tid == selectedTid ? 'light' : null">
      <ion-label class="ion-text-wrap">{{item.name}}</ion-label>
    </ion-item>
  </ion-list>
  <p *ngIf="visible.length == 0" class="ion-text-center ion-padding">
    No matches.
  </p>
  <p *ngIf="hidden > 0" class="ion-text-center ion-padding small">
    {{hidden}} more not shown &mdash; keep typing to narrow the list.
  </p>
</ion-content>
